import { isEmpty, isNil } from 'ramda';

const text = {
  emptyInputError: 'Het veld kan niet leeg zijn',
  keyInputError: 'Alleen kleine letters a-z en cijfers 0-9 toegestaan',
  duplicateKeyErrorMessage:
    'Dezelfde key mag niet meerdere keren gebruikt worden',
  defaultStringErrorMessage: 'Standaard waarde moet een tekst zijn',
  defaultNumberErrorMessage: 'Standaard waarde moet een nummer zijn',
  defaultBooleanErrorMessage: 'Standaard waarde moet een boolean zijn',
};

const KEY_REGEX = /^[a-z0-9_]+$/;

const getValidKeyErrorMessage = (value: string) => {
  if (value.length === 0) return text.emptyInputError;
  return KEY_REGEX.test(value) ? true : text.keyInputError;
};

const getValidationFns = ({
  fieldName,
  duplicateKeys,
}: {
  fieldName: string;
  duplicateKeys: Array<string>;
}) => {
  switch (fieldName) {
    case 'label':
      return [(value: any) => (!isEmpty(value) ? true : text.emptyInputError)];
    case 'key':
      return [
        (value: any) => getValidKeyErrorMessage(value),
        (value: any) =>
          duplicateKeys.includes(value) ? text.duplicateKeyErrorMessage : true,
      ];
    case 'defaultString':
      return [
        (value: any) => {
          if (isNil(value)) return true;
          if (typeof value === 'string') return true;
          return text.defaultStringErrorMessage;
        },
      ];
    case 'defaultNumber':
      return [
        (value: any) => {
          if (isNil(value)) return true;
          if (typeof value === 'number' && !isNaN(value)) return true;
          return text.defaultNumberErrorMessage;
        },
      ];
    case 'defaultBoolean':
      return [
        (value: any) => {
          if (isNil(value)) return true;
          if (typeof value === 'boolean') return true;
          return text.defaultBooleanErrorMessage;
        },
      ];
    default:
      return [];
  }
};

export default getValidationFns;
